// utils
import isTouchDevice from '../utils/touch-device';

const $ = jQuery;
const $window = $(window);

const getHighlightedSlideIdx = (slides) => {
  // this is hardcoded bc there's no actual logic
  // behind selecting the centered item -> it's based on specific text
  // previously this was handled with selecting the last
  // item that had year field filled in but this changed
  // adding extra BE logic doesn't make sense at this point bc this shouldn't change in years
  // ref ticket: https://jira.trio-group.de/browse/NVLG2220045-139
  // currently the most important slide = 'K130 (boats 6-10), Köln class, Corvettes'
  const rgx = /K130\s\((boats|Boote|botes)\s6-10\)/i;
  if (slides.length > 0) {
    const highlightedSlide = slides.find((slide) => {
      const slideTitle = slide.querySelector('.phs-slide-title').innerText;
      return rgx.test(slideTitle);
    });

    // '39' is fallback in case the slides don't load fast enough
    // (39 is the index of the slide we need if filtering is off)
    return highlightedSlide ? Number(highlightedSlide.dataset.slickIndex) : 39;
  }
};

const blockArrows = (
  distanceToBlock,
  nextSlide,
  totalSlides,
  arrowPrev,
  arrowNext,
) => {
  if (nextSlide <= distanceToBlock) {
    arrowPrev.addClass('om-btn-disabled');
  } else if (arrowPrev.hasClass('om-btn-disabled')) {
    arrowPrev.removeClass('om-btn-disabled');
  }
  if (totalSlides - nextSlide <= distanceToBlock) {
    arrowNext.addClass('om-btn-disabled');
  } else if (arrowNext.hasClass('om-btn-disabled')) {
    arrowNext.removeClass('om-btn-disabled');
  }
};

const removeExtendedClass = (slide, slider) => {
  slide.removeClass('phs-slide-extended');
  slider.removeClass('phs-extended');
};

const goToClickedSlide = (slider, currSlide, clickedSlide, dontAnimate) => {
  if (currSlide !== clickedSlide) {
    slider.slick('slickGoTo', clickedSlide, dontAnimate);
  }
};

const reIndexSlider = () => {
  let startingIndex = 0;
  $.each($('.phs-slide'), function (i, slide) {
    $(slide).attr('data-slick-index', startingIndex);
    startingIndex += 1;
  });
};

const filterSlider = (slider, filterVal, slide) => {
  // remove extended slide classes
  removeExtendedClass(slide, slider);
  // reset filters, will filter again later if not 'all'
  slider.slick('slickUnfilter');

  let goToDelay = 0;
  if (!$('.phs-slider-loader').is(':hidden')) {
    goToDelay = 500;
    $('.phs-slider-loader').css('visibility', 'visible');
    $('.phs-slider-loader').css('opacity', '1');
  }

  // filter by TX, but only if not 'all'
  if (filterVal !== 'all') {
    slider.slick('slickFilter', `.${filterVal}`);
  }

  // gets new indexes, bc slides changed with filtering
  reIndexSlider();
  // get slides -> must do after reIndex()
  // .get() transforms it in array (?? we should remove jQuery)
  const slides = slider.find('.phs-slide').get();
  // wait for _something? - load I guess_, then hide loader
  // (@todo not sure if loader is even working, it's a .gif :shrug:)
  setTimeout(function hideLoader() {
    // 'slickGoTo' must be in setTimeout, otherwise
    // the function fires too early
    slider.slick('slickGoTo', getHighlightedSlideIdx(slides), true);
    $('.phs-slider-loader').css('visibility', 'hidden');
    $('.phs-slider-loader').css('opacity', '0');
  }, goToDelay + 10);
};

const initSlider = () => {
  const els = once('history-slider', '.p-history-slider');
  els.forEach((el) => {
    const $wrapper = $(el);
    const $filter = $wrapper.find('.phs-filter-wrapper .phs-filter');
    const $mobileFilter = $wrapper.find('.phs-filter-m select');
    const $slider = $wrapper.find('.phs-slider');
    const $arrowNext = $wrapper.find('.om-slider-arrow-next');
    const $arrowPrev = $wrapper.find('.om-slider-arrow-prev');
    let $slides;

    const milestoneSliderSettings = {
      slidesToShow: 5,
      rows: 0,
      centerMode: true,
      centerPadding: '0px',
      draggable: false,
      touchMove: false,
      infinite: false,
      swipe: false,
      prevArrow: $arrowPrev,
      nextArrow: $arrowNext,
      responsive: [
        {
          breakpoint: 1440, // old breakpoint?
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768, // old breakpoint?
          settings: {
            slidesToShow: 1,
            draggable: true,
            touchMove: true,
            swipe: true,
            centerMode: false,
            dots: true,
            appendDots: $wrapper.find('.om-slider-dots'),
          },
        },
      ],
    };

    $slider.on(
      'init reInit afterChange',
      function (event, slick, currentSlide) {
        const currentSlideNum = (currentSlide || 0) + 1;
        $slider.removeClass('slick-changing');
        $wrapper
          .find('.om-slider-count')
          .text(`${currentSlideNum} of ${slick.slideCount}`);
        $slides = slick.$slides;
      },
    );

    $slider.slick(milestoneSliderSettings);
    // go to the slide that needs to be highlighted (centered)
    // it's based on title, but there's nothing else to go on
    // const $slides = $slider.find('.phs-slide');
    // ^ returns jQuery collection, so all slides that it can find
    if ($slides.length) {
      setTimeout(() => {
        // 'slickGoTo' must be in setTimeout, otherwise
        // the function fires too early
        $slider.slick('slickGoTo', getHighlightedSlideIdx($slides.get()), true);
      }, 300);
    }

    $slider.on(
      'beforeChange',
      function beforeChangeHandler(event, slick, currentSlide, nextSlide) {
        $slider.addClass('slick-changing');
        // Control when arrows should be disabled.
        const currentSliderLen = slick.$slides.length - 1;
        const $winWidth = $window.width();
        // @todo I think these are old breakpoints?
        if ($winWidth > 1440) {
          blockArrows(2, nextSlide, currentSliderLen, $arrowPrev, $arrowNext);
        } else if ($winWidth > 768) {
          blockArrows(1, nextSlide, currentSliderLen, $arrowPrev, $arrowNext);
        }
      },
    );

    // Remove extended class on slides on arrow click
    $('.slick-arrow').on('click', function arrowClickHandler() {
      removeExtendedClass($slides, $slider);
    });

    // Hover functionality on slides
    let setTimeoutConst;
    // @todo can this be on('hover', func) maybe?
    $slides.hover(
      function hoverHandler() {
        if (
          !$slider.hasClass('phs-extended') &&
          !$slider.hasClass('slick-changing') &&
          !isTouchDevice()
        ) {
          const $this = $(this);
          const $slickTrack = $this.closest('.slick-track');
          const $title = $this.find('.phs-slide-title');
          // @todo the width expands to the side, maybe
          // from center would be better
          const $oldWidth = $this.width();

          setTimeoutConst = setTimeout(function () {
            $slides.addClass('hover-show');
            $this.addClass('hover-hidden');
            $slickTrack.width($slickTrack.width() + 80);
            $title.width($title.width());
            $this.data('old-width', $oldWidth);
            $this.width($oldWidth + 80);
          }, 300);
        }
      },
      function () {
        clearTimeout(setTimeoutConst);
        const $this = $(this);
        const $slickTrack = $this.closest('.slick-track');
        $slides.removeClass('hover-show');
        $this.removeClass('hover-hidden');
        $this.width($this.data('old-width'));
        $slickTrack.css('left', 0);
      },
    );

    // Slide click functionality (extended slides & go to slides on click)
    $slides.on('click', function clickHandler() {
      const $this = $(this);
      const $slickTrack = $this.closest('.slick-track');
      const $currentActive = $slider.slick('slickCurrentSlide');
      const $clickedSlide = Number($this.attr('data-slick-index'));
      let delayTime = 500;
      if ($currentActive === $clickedSlide) {
        delayTime = 0;
      }
      if ($('.phs-mobile-controls-wrapper').is(':hidden')) {
        // reset to old width in case slide is hovered
        $this.width($this.data('old-width'));
        // go to clicked slide
        goToClickedSlide($slider, $currentActive, $clickedSlide, false);
        // handle classes for slides
        if ($this.hasClass('phs-slide-extended')) {
          $this.removeClass('phs-slide-extended');
          setTimeout(function () {
            $slider.removeClass('phs-extended');
          }, 300);
        } else {
          setTimeout(function () {
            // @todo where is 801 coming from?
            $slickTrack.width($slickTrack.width() + 801);
            $slides.removeClass('phs-slide-extended');
            $this.closest('.slick-track').css('left', 0);
            $this.addClass('phs-slide-extended');
            $slider.addClass('phs-extended');
          }, delayTime);
          delayTime = 500;
        }
      }
    });

    // Mobile extended click, show text for all slides on extend
    $('.phs-mobile-control').on('click', function mobileClickHandler() {
      if ($slider.hasClass('phs-all-extended')) {
        $slider.removeClass('phs-all-extended');
      } else {
        $slider.addClass('phs-all-extended');
      }
    });

    // Desktop/Tablet filter
    $filter.on('click', function clickFilterHandler() {
      const currentFilterClass = $(this).attr('data-filter');
      $filter.removeClass('active');
      $(this).addClass('active');
      filterSlider($slider, currentFilterClass, $slides);
    });

    // Mobile filter (select dropdown)
    $mobileFilter.on('change', function changeHandler() {
      const currentFilterVal = this.value;
      filterSlider($slider, currentFilterVal);
    });
  });
};

$window.on('load', function startSlider() {
  initSlider();
});
